import { Matrix as i, Quaternion as r } from "@babylonjs/core/Maths/math.vector.js";
function u(t) {
  return t && [
    -t[0],
    t[2],
    t[1]
  ];
}
function m(t) {
  if (!t) return t;
  const n = new i();
  new r(t[0], t[1], t[2], t[3]).toRotationMatrix(n);
  const a = n.multiply(e), o = r.FromRotationMatrix(a);
  return [
    o.x,
    o.y,
    o.z,
    o.w
  ];
}
var e = i.FromArray([
  -1,
  0,
  0,
  0,
  0,
  0,
  1,
  0,
  0,
  1,
  0,
  0,
  0,
  0,
  0,
  1
]);
export {
  m as n,
  u as t
};

//# sourceMappingURL=zipAnchorConversion-B_49vmUS.js.map